/**
 * Uploads an image to a backend entity endpoint.
 * The backend proxies the file to the CDN, stores the public URL
 * in the entity record, and returns the updated entity.
 *
 * Endpoints disponibles:
 *   PUT /product/{uuid}/image
 *   PUT /device/{uuid}/image
 *   PUT /locations/{uuid}/location-image
 *   PUT /locations/{uuid}/diagram-image
 *
 * @param {object} req      - requets() instance (carries the Bearer token)
 * @param {string} endpoint - Entity image path, e.g. `/product/${uuid}/image`
 * @param {File}   file     - Raw File object (Ant Design Upload's originFileObj)
 * @returns {Promise<object>} Updated entity returned by the backend
 */
export const uploadEntityImage = async (req, endpoint, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await req.put(endpoint, formData);
  return response.data;
};
